import { Routes, Route } from "react-router-dom";
import Layout from "./layouts/Layout"; // Importation du layout
import Tcs from "./pages/TCS/Tcs";
import Home from "./pages/Home/Home";
import Article from "./pages/Blog/Article";
import Blog from "./pages/Blog/Blog";
import ErrorPage from "./components/ErrorPage";
import AuthLayout from "./layouts/AuthLayout";
import DashboardLayout from "./layouts/DashboardLayout";
import PrivateRoute from "./app/PrivateRoute";
import Signin from "./app/auth/Signin";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { AuthProvider } from "./app/AuthContext";
import Board from "./app/dashboard/Board";
import ArchivedArticle from "./app/dashboard/blog/ArchivedArticle";
import EditArticle from "./app/dashboard/blog/EditBlogArticle";
import BlogArticleView from "./app/dashboard/blog/BlogArticleView";
import NewArticle from "./app/dashboard/blog/NewArticle";
import BlogApp from "./app/dashboard/blog/BlogApp";
import Users from "./app/dashboard/users/Users";
import AddUser from "./app/dashboard/users/AddUser";
import AboutUs from "./pages/About/AboutUs";
import Contact from "./pages/Contact/Contact";
import Work from "./pages/Work/Work";
import ProjectPage from "./pages/ProjectPage/ProjectPage";
import JobsApp from "./app/dashboard/team/JobsApp";
import NewMember from "./app/dashboard/team/NewMember";
import JobView from "./app/dashboard/team/JobView";
import JobEdit from "./app/dashboard/team/JobEdit";
import ArchivedJobs from "./app/dashboard/team/ArchivedJobs";
import ProjectsBlog from "./app/dashboard/work/ProjectsBlog";
import NewProject from "./app/dashboard/work/NewProject";
import ProjectView from "./app/dashboard/work/ProjectView";
import ScrollToTop from "./components/ScrolltoTop/ScrollToTop";
import EditProject from "./app/dashboard/work/EditProject";
import ArchivedProject from "./app/dashboard/work/ArchivedProject";
import Authors from "./app/dashboard/author/Authors";
import AddAuthor from "./app/dashboard/author/AddAuthor";
import PasswordRecovery from "./app/auth/PasswordRecovery";

import ReactGA from 'react-ga4';
import WeAreHiring from "./pages/WeAreHiring/WeAreHiring";

ReactGA.initialize("G-JMFL70GQEF");

const App = () => {

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setCurrentUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black z-50">
        <div className="w-16 h-16 border-8 border-white border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  return (
    <AuthProvider value={{ currentUser }}>
      <ScrollToTop />
      <Routes>

        <Route path="/" element={<Layout />}>

          <Route index element={<Home />} />
          <Route path="/about" element={<AboutUs />} />

          <Route path="/contact" element={<Contact />} />

          {/* <Route path="/tcs" element={<Tcs />} /> */}

          <Route path="/work" element={<Work />} />
          <Route path="/work/project/:id" element={<ProjectPage />} />

          <Route path="media" element={<Blog />} />
          <Route path="media/:id" element={<Article />} />

          <Route path="wearehiring" element={<WeAreHiring />} />

          <Route path="*" element={<ErrorPage />} />

        </Route>

        <Route path="/auth" element={<AuthLayout />}>
          <Route path="/auth" element={<Signin />} />
          <Route path="passwordrecovery" element={<PasswordRecovery />} />
        </Route>

        <Route path="/dashboard/" element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }>

          <Route path="/dashboard/" element={<Board />} />

          <Route path="blogapp/" element={<BlogApp />} />
          <Route path="blogapp/new-article" element={<NewArticle />} />
          <Route path="blogapp/view/:id" element={<BlogArticleView />} />
          <Route path="blogapp/edit/:id" element={<EditArticle />} />
          <Route path="blogapp/archives" element={<ArchivedArticle />} />

          <Route path="users/" element={<Users />} />
          <Route path="users/adduser" element={<AddUser />} />

          <Route path="team/" element={<JobsApp />} />
          <Route path="team/new-member" element={<NewMember />} />
          <Route path="team/jobview/:id" element={<JobView />} />
          <Route path="team/edit/:id" element={<JobEdit />} />
          <Route path="team/archives" element={<ArchivedJobs />} />

          <Route path="projectapp/" element={<ProjectsBlog />} />
          <Route path="projectapp/new-project" element={<NewProject />} />
          <Route path="projectapp/projectview/:id" element={<ProjectView />} />
          <Route path="projectapp/edit/:id" element={<EditProject />} />
          <Route path="projectapp/archives" element={<ArchivedProject />} />

          <Route path="authors/" element={<Authors />} />
          <Route path="authors/addauthor" element={<AddAuthor />} />

        </Route>

      </Routes>
    </AuthProvider>
  );
};

export default App;
